import { BaseClaraForPlannersEventTracking } from '@/modules/ai/models/segmentevents/BaseClaraForPlannersEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import type { AuthUser } from '@/modules/auth/models/AuthUser';
import type { ClaraConversationObject } from '@/modules/ai/models/ClaraConversationObject';

export class ClaraForPlannersQuestionAskedEventTracking extends BaseClaraForPlannersEventTracking {
  static eventName: string = SegmentEvent.CLARA_QUESTION_ASKED;

  messageIndex: number;
  isSeededQuestion: boolean;

  constructor(
    authUser: AuthUser | null,
    sessionId: string,
    conversation: ClaraConversationObject,
    isSeededQuestion: boolean
  ) {
    super(authUser, sessionId);
    this.messageIndex = conversation.questions.length - 1;
    this.isSeededQuestion = isSeededQuestion;
  }
}
